<section fxLayout="column" fxLayoutGap="12px">
  <p class="text-center">Are you sure? Deleted codes will not be recreated or have a backup.</p>

  <section fxLayoutAlign="center center" fxLayoutGap="8px">
    <sbnb-button size="mini" type="secondary" (clicked)="dialogRef.close(false)">Cancel</sbnb-button>
    <sbnb-button size="mini" (clicked)="dialogRef.close(true)">Delete</sbnb-button>
  </section>
</section>
